
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import Title from '../Title/index.vue'
import LazyImg from '@/components/lazyImg/index.vue'

@Observer
@Component({
  components: {
    Title,
    LazyImg
  }
})
export default class Experience extends Vue {
  get UserStore() {
    return this.$store.$storeUser
  }

  experienceBtn() {
    this.$router.push({ name: 'experience' })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
